import { useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import Login from "@/components/Login";
import { useUserDetails } from "@/features/user/useUserQueries";
import { useUserInfo } from "hooks/useUser";
import { redirectAfterAuth, resolvePostLoginRedirect } from "@/utils/authRedirectUtils";

export default function AuthPage() {
  const router = useRouter();
  const { data: user, isSuccess } = useUserDetails();
  const { setUserInfo } = useUserInfo();

  useEffect(() => {
    if (isSuccess) {
      setUserInfo(user);
    }
  }, [isSuccess, user, setUserInfo]);

  useEffect(() => {
    if (!isSuccess || !user) {
      return;
    }

    const destination = resolvePostLoginRedirect({
      returnUrl: router.query.return_url,
      rt: router.query.rt,
      query: router.query,
    });
    if (destination.url !== "/") {
      redirectAfterAuth(destination);
    }
  }, [isSuccess, user, router.query]);

  return (
    <>
      <Head>
        <title>Genie - Login</title>
      </Head>
      <div className="flex min-h-[100svh] w-full items-center justify-center bg-gray-800 text-center text-white">
        <div>
          <Login />
        </div>
      </div>
    </>
  );
}
